<fullscreen-page>
  <div slot="content" class="p-2 flex-fill overflow-hidden">
    <dx-data-grid #grid [(dataSource)]="dataSource" [height]="'100%'" (onEditingStart)="onEditingStart($event)" (onInitNewRow)="onInitNewRow($event)">
      <dxo-search-panel [visible]="true" [width]="240"/>    
    
      <dxo-editing mode="popup" [allowAdding]="true" [allowUpdating]="true" [allowDeleting]="true">
        <dxo-data-grid-popup title="{{ 'Prompt Editor' | translate }}" [showTitle]="true" contentTemplate="popupContent">
          <dxi-data-grid-toolbar-item toolbar="bottom" location="after" widget="dxButton"
                                      [options]="{ stylingMode: 'outlined', text: 'Abbrechen', onClick: onCancelEdit }">
          </dxi-data-grid-toolbar-item>
          <dxi-data-grid-toolbar-item toolbar="bottom" location="after" widget="dxButton"
                                      [options]="{ stylingMode: 'outlined', text: 'Speichern', type: 'default', onClick: onSaveEdit }">
          </dxi-data-grid-toolbar-item>    
    
        </dxo-data-grid-popup>
      </dxo-editing>
      <dxo-paging enabled="true"/>
      <dxo-search-panel enabled="true"/>
    
      <dxo-toolbar>
        <dxi-item location="before" name="addRowButton"/>
        <dxi-item location="after" name="searchPanel"/>
      </dxo-toolbar>
      <div *dxTemplate="let data of 'popupContent'">
        <aiprompt-editor [prompt]="editedPrompt"/>
      </div>
    
      <dxi-column title="{{ 'Name' | translate }}" dataField="name"/>
      <dxi-column title="{{ 'Model' | translate }}" dataField="model" cellTemplate="modelTpl"/>
    
      <div *dxTemplate="let cell of 'modelTpl'">
        {{ cell.data.provider }} | {{ cell.data.model }}
      </div>
    
      <!--  Buttons für die Listen Elemente -->
      <dxi-column type="buttons" [width]="160">
        <dxi-button icon="edit" name="edit" hint="Bearbeiten"></dxi-button>
        <dxi-button icon="trash" name="delete" hint="Löschen"></dxi-button>
    
        
        <dxi-button *ngIf="hasCustomersList"
                    icon="copy"
                    hint="{{'Duplizieren' | translate}}"
                    [onClick]="duplicateAiPrompt">
        </dxi-button>      
      </dxi-column>
    </dx-data-grid>
  </div>
</fullscreen-page>        
        
<!-- Copy prompt popup -->
<dx-popup class="popup"
          [width]="600"
          [height]="250"
          [showTitle]="true"
          title="{{ 'Zielaccount auswählen' | translate }}"
          [dragEnabled]="false"
          [hideOnOutsideClick]="true"
          [showCloseButton]="true"
          [(visible)]="isSelectCustomerVisible"
          contentTemplate="selectCustomerContent">
  <div *dxTemplate="let data of 'selectCustomerContent'">

    <div class="dx-field d-flex flex-row">
      <div class="dx-field-label">{{ 'Zielaccounts' | translate }}</div>
      <div class="dx-field-value {{ showPlaceHolders ? 'inputWithPlaceHolder' : 'inputWithOutPlaceHolder' }}">
        <label class="placeLabel {{ selectedCustomers?.length > 0 ? 'placeLabelSmall' : '' }}">{{ 'Zielaccounts auswählen' | translate }}</label>
        <dx-drop-down-box [(value)]="selectedCustomers"
                          valueExpr="id"
                          displayExpr="name"
                          [showClearButton]="true"
                          [dataSource]="customers">
          <div *dxTemplate="let data of 'content'">
            <dx-data-grid [dataSource]="customers"
                          keyExpr="id"
                          [columns]="['name']"
                          [selection]="{ mode: 'multiple' }"
                          [hoverStateEnabled]="true"
                          [paging]="{ enabled: true, pageSize: 10 }"
                          [filterRow]="{ visible: true }"
                          [scrolling]="{ mode: 'infinite' }"
                          [height]="345"
                          [(selectedRowKeys)]="selectedCustomers">
            </dx-data-grid>
          </div>
        </dx-drop-down-box>
      </div>
    </div>
    <div class="dx-field d-flex flex-row">
      <dx-button stylingMode="text"
                 type="default"
                 [disabled]="!canCopy()"
                 text="{{ 'Kopieren' | translate }}"
                 (onClick)="copyTemplate($event)"></dx-button>
    </div>
  </div>
</dx-popup>
